var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-portail",attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"app-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }